import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Container, Box, Typography, Button, CircularProgress, Alert, Chip,
} from '@mui/material';
import { Settings, Visibility, VisibilityOff } from '@mui/icons-material';
import ProfileCard from '../../components/profile/ProfileCard';
import { profileService } from '../../services/profileService';

const ProfileViewPage: React.FC = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [profile, setProfile] = useState<any>(null);
  const [privacyState, setPrivacyState] = useState<string>('private');

  useEffect(() => {
    profileService.getMyProfile()
      .then((res) => {
        setProfile(res.data.profile);
        setPrivacyState(res.data.privacyState || 'private');
      })
      .catch((err) => {
        setError(err.response?.data?.message || 'プロフィールの取得に失敗しました');
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="md" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>
        <Button variant="outlined" onClick={() => navigate('/athlete/dashboard')}>
          ダッシュボードに戻る
        </Button>
      </Container>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f5f5f5' }}>
      <Box sx={{ bgcolor: '#0066cc', color: 'white', py: 3 }}>
        <Container maxWidth="md">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="h4" sx={{ fontWeight: 600, fontSize: { xs: '1.5rem', md: '2rem' } }}>
              キャリアプロフィール
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Chip
                icon={privacyState === 'anonymous_public' ? <Visibility /> : <VisibilityOff />}
                label={privacyState === 'anonymous_public' ? '匿名公開中' : '非公開'}
                color={privacyState === 'anonymous_public' ? 'success' : 'default'}
                sx={{ color: 'white', '& .MuiChip-icon': { color: 'white' } }}
                variant="outlined"
              />
              <Button
                variant="outlined"
                startIcon={<Settings />}
                onClick={() => navigate('/profile/settings')}
                sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)' }}
              >
                公開設定
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 4 }}>
        <ProfileCard profile={profile} />

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Button variant="outlined" onClick={() => navigate('/athlete/dashboard')}>
            ダッシュボードに戻る
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default ProfileViewPage;
